module.exports = __webpack_public_path__ + "media/brands/img2-2b21f74f.jpg";